
import * as net from "./network/net";
import Jackpot from "./jackpot";
const network = require( "./network/network_api" );
import { REQUEST_TYPE } from "./network/net";

export default function(
    $state,
    $request,
    view,
    $uiStart,
    $lastRequest,
    parent,
)
{
    const space = parent.child( "jackpot" );
    
    const $jackpotState = $state
        .map( state => state.type == network.TYPE.JACKPOT ? state : undefined )
        .distinctUntilChanged( _.isEqual );
    
    const $play = space.s( "play" );
    const $restore = space.s( "restore" );
    const $hide = space.s( "hide" );
    const $isIn = space.s( "isIn", false );
    $jackpotState
        .withLatestFrom(
            $lastRequest,
            $isIn,
            ( state, lastRequest, isIn ) => ({ state, lastRequest, isIn })
        )
        .subscribe( ({ state, lastRequest, isIn }) =>
        {
            if ( state === undefined )
            {
                if ( isIn )
                {
                    $isIn.next( false );
                    $hide.next( true );
                }
                return;
            }
            
            $isIn.next( true );
            
            if ( lastRequest == REQUEST_TYPE.PROCEED || lastRequest == REQUEST_TYPE.SPIN )
            {
                $play.next( state );
            }
            else
            {
                $restore.next( state );
            }
        } );
    
    const $start = space.s( "start" );
    $uiStart.to( $start );
    
    space.s( "click" ).to( $start );
    
    const ENTER = 13;
    const SPACE = 32;
    const F8    = 119;
    parent.s( "keyboard" )
        .filter( event => _.includes( [ ENTER, SPACE, F8 ], event ) )
        .to( $start );
    
    const jackpot = Jackpot(
        space,
        view
    );
    
    $start
        .withLatestFrom(
            $jackpotState,
            space.s( "flowing" ),
            parent.s( "pending" ),
            ( start, state, flowing, pending ) => ({ state, flowing, pending })
        )
        .filter( ({ state, flowing, pending }) =>
            state !== undefined
            &&
            ! flowing
            &&
            pending === undefined
        )
        .map( () => ({ type : REQUEST_TYPE.PROCEED }) )
        .subscribe( $request );
    
    return space;
}



// WEBPACK FOOTER //
// ./src/library/jackpot_driver.es6